import { render } from "./Cronometro.vue?vue&type=template&id=4d056978&ts=true"
import script from "./Cronometro.vue?vue&type=script&lang=ts"
export * from "./Cronometro.vue?vue&type=script&lang=ts"

import "./Cronometro.vue?vue&type=style&index=0&id=4d056978&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__